import { Component } from '@angular/core';

import { Util } from '../../shared/util';
import { MessageService } from 'primeng/components/common/messageservice';
import { WebPage } from '../../shared/web-page';
import { CandidatoService } from '../candidato.service';

@Component({
  templateUrl: './consultar-convocacao.component.html',
})
export class ConsultarConvocacaoComponent extends WebPage {

  candidato;
  consultou = false;

  constructor(private candidatoService: CandidatoService, messageService: MessageService) {
    super(messageService);
  }

  consultaCpf(cpf) {
    this.isLoading = true;
    this.candidatoService.getByCpf(Util.limpaCpf(cpf))
      .finally(() => this.isLoading = false)
      .subscribe(
        candidato => {
          this.consultou = true;
          this.candidato = candidato;
        },
        error => this.gerenciaErro(error)
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/candidato/consultar-convocacao/consultar-convocacao.component.ts